import React, { useState } from "react";

// components
import { Row, Col, Button,FormGroup, Spinner, Input, Label } from "reactstrap";
import PendenciasGE from "./components/PendenciasGE";
import InputDatePickerMesAno from "components/Inputs/InputDatePickerMesAno";
import { CSVLink  } from "react-csv";

// utils
import { getSessionCookie } from 'utils/cookies';
import { formateMesAno, formateDateByMesAno } from "utils/formats";
import { showMessage } from "utils/message.js";

// api
import relatorio_api from "api/relatorio_api";

export default function Inicio({ history }) {

  var session = getSessionCookie();

  const exportRef = React.useRef(null);
  const exportRef2 = React.useRef(null);

  const [showLoading, setshowLoading] = useState(false);
  const [startDate, setStartDate] = useState(formateDateByMesAno(session.mesAnoDefault));
  const [endDate, setEndDate] = useState(formateDateByMesAno(session.mesAnoDefault));
  const [list_table, set_list_table] = useState([]);

  const headersExport = [
    { label: 'Mes Ano Inicial', key: 'mesAnoInicial' },
    { label: 'Mes Ano Final', key: 'mesAnoFinal' },
    { label: 'Grupo Econômico', key: 'grupoEconomico' },
    { label: 'Qtd PDV', key: 'qtdePdv' },
    { label: 'Qtd PDV c/ Pendencia', key: 'qtdePdvPendencia' },
    { label: 'Status', key: 'statusDRE' },
    { label: 'Data Emissão Relatório', key: 'dataEmissaoRelatorio'}
]
  const [csvData, set_csvData] = useState([]);

  const handleExportar = () => {
    setshowLoading(true);
    let body={
      startDate: startDate,
      endDate: endDate,
      grupoEconomico: null
    }
    relatorio_api.getApuracaoDreMensalGE(body).then(result => {
      setshowLoading(false);
      if (result.status !== 200) {
        showMessage("Aviso", result.message, 'error', null);
      }
      else {
          if (result.data.length == 0) {
              showMessage("Aviso", "Não existem dados para os filtros informados", 'error', null);
              return;
          }
          set_csvData(result.data);
          exportRef.current.link.click();
      }
    })
  }

  const headersExport2 = [
    { label: 'Mes Ano', key: 'mesAno' },
    { label: 'Grupo Econômico', key: 'grupoEconomico' },
    { label: 'Cust Code', key: 'custCode' },
    { label: 'Nick Name', key: 'nickName' },
    { label: 'Status Dre', key: 'statusDre'},
    { label: 'Pendencia', key: 'pendencia' },
    { label: 'Data Implantação', key: 'dataImplantacaoString' },
    { label: 'Data Emissão Relatório', key: 'dataEmissaoRelatorio'}
]
  const [csvData2, set_csvData2] = useState([]);

  const handleExportarDetalhado = () => {
    setshowLoading(true);
   
    let body={
      startDate: startDate,
      endDate: endDate,
      grupoEconomico: null
    }
    relatorio_api.getApuracaoDreMensalLoja(body).then(result => {
      setshowLoading(false);
      if (result.status !== 200) {
        showMessage("Aviso", result.message, 'error', null);
      }
      else {
          if (result.data.length == 0) {
              showMessage("Aviso", "Não existem dados para os filtros informados", 'error', null);
              return;
          }
          set_csvData2(result.data);
          exportRef2.current.link.click();
      }
    })
  }


  const handleFiltrar = () => {
    set_list_table([]);
    setshowLoading(true);
    let body={
      startDate: startDate,
      endDate: endDate,
      grupoEconomico: null
    }
    relatorio_api.getApuracaoDreMensalGE(body).then(result => {
        setshowLoading(false);
        if (result.status !== 200) {
            showMessage("Aviso", result.message, 'error', null);
        }
        else {
            if (result.data.length == 0) {
                showMessage("Aviso", "Não existem dados para os filtros informados", 'error', null);
                return;
            }

            set_list_table(result.data);
        }
    })
}

  return (
    <>
      {showLoading &&
        <div className="carregandoCmp">
          <div className="box">
            <Spinner></Spinner>
          </div>
        </div>
      }
      <div className="content">
        <Row className="mb-4 align-items-end">
            <Col lg="12" md="12" sm="12"><h4 className="mt-0 mb-0">Relatório Apuração DRE - Pendencias Acumuladas</h4></Col>
        </Row>
        <Row className="mb-4 align-items-end">
            <Col lg="2" md="6" sm="12">
                <FormGroup>
                    <label className="form-control-label">Mês/Ano (inicial)</label>
                    <InputDatePickerMesAno selected={startDate} onChange={(date) => setStartDate(date)} ></InputDatePickerMesAno>
                </FormGroup>
            </Col>
            <Col lg="2" md="6" sm="12">
                <FormGroup>
                    <label className="form-control-label">Mês/Ano (final)</label>
                    <InputDatePickerMesAno selected={endDate} onChange={(date) => setEndDate(date)} ></InputDatePickerMesAno>
                </FormGroup>
            </Col>
            <Col lg="2" md="6" sm="12">
                <Button color="info" type="button" onClick={handleFiltrar}><i className="fas fa-filter"></i>  Filtrar</Button>
            </Col>
            <Col lg="6" md="6" sm="12" >
              <div style={{textAlign:'right'}}>
              <Button color="success" type="button" onClick={handleExportar}><i className="fas fa-download"></i>  Exportar Consolidado</Button>
              {csvData.length > 0 &&
                <CSVLink data={csvData} headers={headersExport} filename="ApuracaoMensalDreConsolidado.csv" target="_blank" ref={exportRef}></CSVLink>
              }
              <Button color="success" type="button" onClick={handleExportarDetalhado}><i className="fas fa-download"></i>  Exportar Detalhado</Button>
              {csvData2.length > 0 &&
                <CSVLink data={csvData2} headers={headersExport2} filename="ApuracaoMensalDreDetalhado.csv" target="_blank" ref={exportRef2}></CSVLink>
              }
              </div>
            </Col> 
        </Row>
        {list_table.length > 0 && 
        <div>
          <PendenciasGE  list_table={list_table} startDate={startDate} endDate={endDate}></PendenciasGE>
        </div>
        }
      </div>
    </>

  );
}